import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  message: string | null = null; // Store a single message

  show(msg: string) {
    this.message = msg;
    setTimeout(() => this.clear(), 5000); // Auto-hide after 3 seconds
  }

  clear() {
    this.message = null;
  }
}
